import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDT } from "@/lib/format";
import { Button } from "@/components/ui/button";

export default function MobileAlerts() {
  const [notifs, setNotifs] = useState([]);

  const load = () => api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="p-4" data-testid="mobile-alerts">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] uppercase tracking-[0.15em] font-bold text-muted-foreground">Notifications</div>
        <Button size="sm" variant="outline" className="rounded-none" data-testid="read-all-button" onClick={readAll}>Mark all read</Button>
      </div>
      {notifs.length === 0 && <div className="font-mono text-xs text-muted-foreground border border-border p-6">No notifications</div>}
      <div className="space-y-2">
        {notifs.map((n) => (
          <div key={n.id} className={`border p-3 ${n.read ? "border-border opacity-60" : "border-[hsl(var(--warning))] bg-card"}`} data-testid={`notif-${n.id.slice(0, 8)}`}>
            <div className="text-sm font-semibold">{n.title}</div>
            <div className="text-xs text-muted-foreground mt-1">{n.body}</div>
            <div className="font-mono text-[10px] text-muted-foreground mt-1">{fmtDT(n.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
